module.exports = __webpack_public_path__ + "img/thomas_mohr.6a55d516.jpg";